// HubSpot browser helpers
export const getHutk = () => {
  try {
    const m = document.cookie.match(/(?:^|; )hubspotutk=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : null;
  } catch (e) {
    return null;
  }
};

export const hubspotContext = () => ({
  hutk: getHutk(),
  page_url: typeof window !== "undefined" ? window.location.href : null,
});
